import * as React from 'react';
import { getAttributionData, getIsBot, recordAttributionAnalytics } from '@/redux/modules/analytics';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import isEqual from 'react-fast-compare';
import usePrevious from '@/hooks/usePrevious';

/**
 * Record Segment.io attribution data on first page load
 */
const SegmentTracker = () => {
    const attributionData = useAppSelector(getAttributionData, isEqual);
    const isBot = useAppSelector(getIsBot);
    const prevBidderId = usePrevious(attributionData.bidderId);
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        if (prevBidderId !== attributionData.bidderId && !isBot) {
            dispatch(recordAttributionAnalytics(attributionData));
        }
    }, [attributionData, isBot, prevBidderId, dispatch]);

    return null;
};

export default SegmentTracker;
